export default "__VITE_ASSET__BcAILeTP__"